import styled from 'styled-components';

export const MainContent = styled.main`
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);

  td {
    vertical-align: middle;
  }

  .details {
    padding: 15px 0 20px;
    display: flex;
    gap: 25px;
    align-items: center;

    * {
      flex: 0 0 auto;
    }

    button {
      width: auto;
    }

    .select {
      width: 190px;
      line-height: 14px;
      box-shadow: #cadcf8 0 0 0 1px;
      :hover {
        box-shadow: #2f5d87 0 0 0 1px;
      }
    }
    .select-wrapper {
      width: 190px;
      .optionsWrapper {
        width: 190px;
        top: -8px;
      }
      .icon--opened {
        right: 0;
      }
      .icon--closed {
        right: 15px;
      }
    }

    .left {
      color: #b4b9d9;

      .name {
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        text-transform: capitalize;
      }

      .price {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        text-transform: capitalize;
      }
    }

    .divider {
      border-right: 1px solid var(--color-border);
      height: 40px;
    }

    .count {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      color: var(--color-text-muted);
      border: 1px solid var(--color-border);
      border-radius: 10px;
      padding: 0 16px;
      height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .bold {
        font-weight: bold;
      }
    }
  }

  .pencil {
    cursor: pointer;

    :hover {
      color: #858dbd;
    }
  }
`;
